import React, { useState } from "react";

import { i18n } from "../../translate/i18n";

export default function TailwickCopyButton({ content }) {
	const [copied, setCopied] = useState(false);

	const handleCopy = async () => {
		try {
			await navigator.clipboard.writeText(String(content || ""));
			setCopied(true);
			window.setTimeout(() => setCopied(false), 1800);
		} catch {
			/* ignore */
		}
	};

	const label = copied
		? i18n.t("copyToClipboard.copied")
		: i18n.t("copyToClipboard.copy");

	return (
		<button
			type="button"
			className="inline-flex size-7 shrink-0 items-center justify-center rounded-md text-default-500 transition-colors hover:bg-default-150 hover:text-primary"
			onClick={handleCopy}
			title={label}
			aria-label={label}
		>
			<svg className="size-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
				<rect width="14" height="14" x="8" y="8" rx="2" ry="2" />
				<path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
			</svg>
		</button>
	);
}
